import { useQuery } from '@tanstack/react-query';

import { getBannerMessagesApi } from 'api/notifications';
import type {
  GetBannerMessagesResponseDTO,
  GetBannerMessagesResponseParamsDTO,
} from 'declarations/dto/notifications';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchBannerMessages = (
  params: GetBannerMessagesResponseParamsDTO
): ReturnType<typeof useQuery<GetBannerMessagesResponseDTO, ApiErrorI>> =>
  useQuery<GetBannerMessagesResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchBannerMessages, params],
    async (): Promise<GetBannerMessagesResponseDTO> => getBannerMessagesApi(params)
  );
